import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faQuestionCircle as farQuestionCircle,
  faCheckCircle as farCheckCircle,
  faTimesCircle as farTimesCircle,
} from '@fortawesome/free-regular-svg-icons'
import {
  faBullhorn,
  faGavel,
  faHourglassHalf,
  faClock,
  faBalanceScale,
  faCoins,
  faInfoCircle,
  faExternalLinkAlt,
  faSearch,
  faBell,
  faFileAlt,
  faCheck,
  faExclamationTriangle,
  faShieldAlt,
  faPlus,
  faPlusCircle,
  faFire,
  faStar,
  faCheckCircle,
  faFlag,
  faFilePdf,
  faArrowCircleRight,
  faArrowLeft,
  faArrowRight,
  faPaperclip,
  faTimes,
  faFile,
  faDollarSign,
  faSpinner,
  faQuestionCircle,
  faCopy,
  faChevronLeft,
  faChevronRight,
  faEllipsisH,
  faUpload,
  faChevronDown,
  faChevronUp,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faGavel,
  faHourglassHalf,
  faClock,
  faBalanceScale,
  faCoins,
  faBullhorn,
  faInfoCircle,
  faExternalLinkAlt,
  faSearch,
  faBell,
  faFileAlt,
  faCheck,
  faExclamationTriangle,
  faShieldAlt,
  faPlus,
  faPlusCircle,
  faFire,
  faStar,
  faCheckCircle,
  faFlag,
  faFilePdf,
  faArrowCircleRight,
  faArrowLeft,
  faArrowRight,
  faPaperclip,
  faTimes,
  faFile,
  faDollarSign,
  faSpinner,
  faQuestionCircle,
  farQuestionCircle,
  farCheckCircle,
  farTimesCircle,
  faCopy,
  faChevronLeft,
  faChevronRight,
  faEllipsisH,
  faUpload,
  faChevronDown,
  faChevronUp,
  faTrashAlt,
)
